// extracted by mini-css-extract-plugin
export var background = "bM_y";
export var backgroundContainer = "bM_fp";
export var bottomWave = "bM_c6";
export var buttons = "bM_cn";
export var container = "bM_b";
export var content = "bM_b6";
export var icon = "bM_bw";
export var iconContainer = "bM_b4";
export var middleWave = "bM_c5";
export var negativeTop = "bM_hs";
export var overlap = "bM_hv";
export var section = "bM_j";
export var selected = "bM_bg";
export var tab = "bM_fl";
export var tabText = "bM_fk";
export var title = "bM_g";
export var topWave = "bM_ht";